/**
 * Lecture du négociateur d'un bien — implémentation UNIQUE du projet.
 *
 * Le champ est hétérogène par héritage : `negociateur_id` porte un identifiant, tandis que
 * `negociateur.negociateur` contient, selon l'ancienneté du bien, un identifiant OU un nom en
 * clair (les données de migration et l'ancien sélecteur du formulaire y écrivent un nom).
 * Un affichage direct de la valeur brute est donc faux dans un cas sur deux.
 *
 * Quatre endroits du front lisaient ce champ à leur manière (dont une version morte qui
 * renvoyait toujours une chaîne vide). Ils passent tous par ici.
 */

/** Identifiant du négociateur : le champ plat fait foi, l'imbriqué est le repli. */
export const getNegociateurId = (property) => {
  if (!property) return '';
  if (property.negociateur_id) return property.negociateur_id;
  const imbrique = property.negociateur || property.responsable_dossier;
  if (!imbrique) return '';
  if (typeof imbrique === 'string') return imbrique;
  return imbrique.negociateur || imbrique.id || imbrique._id || '';
};

/**
 * Nom affichable du négociateur.
 * @param {object} property  le bien
 * @param {Array}  annuaire  négociateurs connus : [{id, nom, prenom, civilite}] ou [{id, name}]
 * @param {string} defaut    valeur si aucun négociateur n'est renseigné
 * @returns le nom complet si l'identifiant est résolu, sinon la valeur brute (qui est
 *          précisément un nom en clair sur les biens issus de migration).
 */
export const getNegociateurName = (property, annuaire = [], defaut = 'Non assigné') => {
  const valeur = getNegociateurId(property);
  if (!valeur) return defaut;

  const connu = (annuaire || []).find(n => n && typeof n === 'object' && n.id === valeur);
  if (connu) {
    const complet = [connu.civilite, connu.prenom, connu.nom].filter(Boolean).join(' ').trim();
    return complet || connu.name || valeur;
  }
  return valeur;
};
